var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-nav-bar',{attrs:{"title":"返回","left-arrow":""},on:{"click-left":function($event){return _vm.gohome()}}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageError"},[_c('img',{staticClass:"null-img",attrs:{"src":require("../assets/image/null-data.png"),"alt":""}})])
}]

export { render, staticRenderFns }